// app/javascript/controllers/filters_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["category", "subcategory", "make", "model", "panel", "chevron"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    // Preserve existing enable/disable logic
    this.toggleSubcategory()
    this.toggleModel()

    // Sync collapsed UI state on load
    this._syncUI()
  }

  // === Collapsible panel ===
  togglePanel() {
    this.openValue = !this.openValue
    this._syncUI()
  }
  open() {
    this.openValue = true
    this._syncUI()
  }
  close() {
    this.openValue = false
    this._syncUI()
  }
  _syncUI() {
    const expanded = this.openValue

    if (this.hasPanelTarget) {
      this.panelTarget.classList.toggle("hidden", !expanded)
    }
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.toggle("rotate-180", expanded)
    }

    // Keep aria-expanded in sync on the toggle button if present
    const toggleBtn = this.element.querySelector('[aria-controls="mobile-filters-panel"]')
    if (toggleBtn) toggleBtn.setAttribute("aria-expanded", String(expanded))
  }

  // === Existing submit ===
  submit() { this.element.requestSubmit() }

  // === Category → Subcategory ===
  onCategoryChange() {
    if (this.hasSubcategoryTarget) this.subcategoryTarget.selectedIndex = 0
    this.toggleSubcategory()
    this.submit()
  }
  toggleSubcategory() {
    if (!this.hasSubcategoryTarget) return
    const enabled = this.hasCategoryTarget && this.categoryTarget.value !== ""
    this.subcategoryTarget.disabled = !enabled
    this.subcategoryTarget.classList.toggle("opacity-50", !enabled)
    this.subcategoryTarget.classList.toggle("cursor-not-allowed", !enabled)
  }

  // === Make → Model ===
  onMakeChange() {
    if (this.hasModelTarget) this.modelTarget.selectedIndex = 0
    this.toggleModel()
    this.submit()
  }
  toggleModel() {
    if (!this.hasModelTarget) return
    const enabled = this.hasMakeTarget && this.makeTarget.value !== ""
    this.modelTarget.disabled = !enabled
    this.modelTarget.classList.toggle("opacity-50", !enabled)
    this.modelTarget.classList.toggle("cursor-not-allowed", !enabled)
  }
}
